var map = {
	"./categories.svg": "394b",
	"./categories_green.svg": "0517",
	"./categories_grey_border.svg": "e612",
	"./dd.svg": "7438",
	"./dd_green.svg": "f752",
	"./dd_grey_border.svg": "c669",
	"./dd_orange.svg": "7a4a",
	"./edit_pencil.svg": "f476",
	"./investment.svg": "b98a",
	"./investment_green.svg": "b67b",
	"./investment_grey_border.svg": "abe3",
	"./owner.svg": "7028",
	"./owner_green.svg": "849c",
	"./owner_grey_border.svg": "e563",
	"./plan_name.svg": "6655",
	"./plan_name_green.svg": "d0fa",
	"./plan_name_grey_border.svg": "4fa6",
	"./project_max.svg": "bfb3",
	"./project_max_green.svg": "5325",
	"./project_max_grey_border.svg": "5478",
	"./roundup_grey.svg": "cd8f",
	"./roundup_grey_desktop.svg": "6a57",
	"./roundup_orange.svg": "0160",
	"./strategies.svg": "1ef3",
	"./topup_grey.svg": "98f4",
	"./topup_grey_desktop.svg": "a8ea",
	"./topup_orange.svg": "5b94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2164";